import { graphql } from '@tn/foundation/graphql/__generated/gql';

export const mosaicPageDocumentsCacheKey = 'mosaic-page-documents';

/**
 * The documents a Mosaic PAGE surface renders: the blueprint default, or an
 * experiment variant's document applied over it, with the page-attribute
 * records its sources declare. The signup route prefetches it server-side; the
 * `upsell` child machine refetches it from the browser for a visitor the
 * server could not bucket (see `entities/upsell`).
 */
export const mosaicPageDocumentsQuery = graphql(/* GraphQL */ `
    query MosaicPageDocumentsQuery(
        $pageId: String!
        $cbscidmt: String
        $promo: String
        $flowType: String
        $variants: Boolean
    ) {
        mosaicPageDocuments(
            pageId: $pageId
            cbscidmt: $cbscidmt
            promo: $promo
            flowType: $flowType
            variants: $variants
        ) {
            page
            islands
            variantsForTracking
            resolvedPromo
            sources {
                url
                tag
                version
                sortBy
                sortByOrder
                packageCode
                filterOtherTagged
                records
            }
        }
    }
`);
